(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-gastronomique"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.swiperGastronomique', {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        1024: {
          pagination: {
            el: '.swiper-pagination-gastronomique',
            clickable: true,
            renderBullet: function (index, className) {
              var title = document
                .querySelectorAll('.swiper-slide-gastronomique')
                [index].getAttribute('data-swiperNamePagination');
              return '<span class="' + className + '">' + title + '</span>';
            },
          },
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
